var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { lower } from '../../Utils/string';
function reduceText(text, targetText, split) {
    var firstChar = text[0];
    if (!firstChar || firstChar === split) {
        return text;
    }
    var restText = text;
    var targetTextLen = targetText.length;
    for (var i = 0; i < targetTextLen; i += 1) {
        if (lower(restText[i]) !== lower(targetText[i])) {
            restText = restText.slice(i);
            break;
        }
        else if (i === targetTextLen - 1) {
            restText = restText.slice(targetTextLen);
        }
    }
    return restText;
}
export var omit = function (obj) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    var clone = __assign({}, obj);
    keys.forEach(function (key) {
        delete clone[key];
    });
    return clone;
};
/**
 * 匹配最后一个关键字
 */
export function getLastMeasureIndex(text, prefix) {
    if (prefix === void 0) { prefix = ''; }
    var prefixList = Array.isArray(prefix) ? prefix : [prefix];
    return prefixList.reduce(function (lastMatch, prefixStr) {
        var lastIndex = text.lastIndexOf(prefixStr);
        if (lastIndex > lastMatch.location) {
            return {
                location: lastIndex,
                prefix: prefixStr,
            };
        }
        return lastMatch;
    }, { location: -1, prefix: '' });
}
export function filterOption(input, _a) {
    var _b = _a.value, value = _b === void 0 ? '' : _b;
    var lowerCase = input.toLowerCase();
    return value.toLowerCase().indexOf(lowerCase) !== -1;
}
export function replaceWithMeasure(text, measureConfig) {
    var measureLocation = measureConfig.measureLocation, prefix = measureConfig.prefix, targetText = measureConfig.targetText, selectionStart = measureConfig.selectionStart, split = measureConfig.split;
    var beforeMeasureText = text.slice(0, measureLocation);
    if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
        beforeMeasureText = beforeMeasureText.slice(0, beforeMeasureText.length - split.length);
    }
    if (beforeMeasureText) {
        beforeMeasureText = "" + beforeMeasureText + split;
    }
    var restText = reduceText(text.slice(selectionStart), targetText.slice(selectionStart - measureLocation - prefix.length), split);
    if (restText.slice(0, split.length) === split) {
        restText = restText.slice(split.length);
    }
    var connectedStartText = "" + beforeMeasureText + prefix + targetText + split;
    return {
        text: "" + connectedStartText + restText,
        selectionLocation: connectedStartText.length,
    };
}
export function validateSearch(text, props) {
    var split = props.split;
    return !split || text.indexOf(split) === -1;
}
